<template>
  <div>
    <div>
      <stats-container />
    </div>
  </div>
</template>

<script>
import request from "@/modules/request";
import moment from "moment";
import StatsContainer from "@/components/shared/stats/StatsContainer";

export default {
  name: "AssociateDashboard",
  async mounted() {},
  components: {
    StatsContainer,
  },
  data() {
    return {
      loading: true,
      orders: [],
      ordersTableHeaders: [
        {
          text: "Order ID",
          value: "orderId",
        },
        {
          text: "PO #",
          value: "poNum",
        },
        {
          text: "Customer",
          value: "company.name",
        },
        {
          text: "Order Date",
          value: "orderDate",
        },
        {
          text: "Status",
          value: "orderStatus",
        },
        {
          text: "Order Total",
          value: "formattedOrderTotal",
        },
        {
          text: "",
          value: "action",
        },
      ],
      actions: [
        {
          color: "primary",
          click: this.viewOrder,
          text: "View",
        },
      ],
      orderSummary: [
        {
          value: 3113,
          label: "Submitted Orders",
          color: "primary",
        },
        {
          value: 252,
          label: "Confirmed Orders",
          color: "primary",
        },
        {
          value: 42,
          label: "Completed Orders",
          color: "primary",
        },
      ],
      pendingSummary: [
        {
          value: 15,
          label: "Users Pending Approval",
          color: "primary",
        },
        {
          value: 22,
          label: "Customers Pending Approval",
          color: "primary",
        },
        {
          value: 81,
          label: "Submitted orders in the past 30 days",
          color: "primary",
        },
      ],
    };
  },
  methods: {
    viewOrder(order) {
      this.$router.push({
        name: "AssociateOrder",
        params: {
          id: order._id,
        },
      });
    },
  },
};
</script>
